import { render, staticRenderFns } from "./StopOverlay.vue?vue&type=template&id=dd06c2fc&scoped=true&"
import script from "./StopOverlay.vue?vue&type=script&lang=ts&"
export * from "./StopOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd06c2fc",
  null
  
)

export default component.exports